import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteUser } from "../../api/apiUsers";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف مستخدم (soft delete)
 */
export function useDeleteUser() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteUserMutate,
        isPending,
    } = useMutation({
        mutationFn: deleteUser,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["users"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete user");
        },
    });

    return {
        deleteUserMutate,
        isPending,
    };
}